var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeyondTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo",
    width: 50,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 12 50 70",
    style: {
      fill: "#FF5500"
    },
    alt: "BeyondTrust Logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#FF5500"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.9,39.4l-5.7-5.7c0,0-0.1-0.1-0.2,0c-0.1,0-0.1,0.1-0.1,0.1v40.3c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0l5.7-5.7c0.2-0.2,0.4-0.7,0.4-1V40.4C48.3,40.1,48.1,39.6,47.9,39.4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#FF5500"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,30.3H17.3c-0.2,0-0.3-0.1-0.3-0.3V13c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0l-5.7,5.7 c-0.2,0.2-0.4,0.7-0.4,1v16.9c0,0.1,0.1,0.2,0.2,0.2H31c0.2,0,0.3,0.1,0.3,0.3v3c0,0.4-0.4,0.8-0.8,0.8H10.7c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1l0,21.6c0,2.5,2,4.5,4.5,4.5h15.5c0.4,0,0.8,0.4,0.8,0.8v3c0,0.2-0.1,0.3-0.3,0.3H15c-4.8,0-8.6-3.9-8.6-8.6v-39 c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0l-5.7,5.7c-0.2,0.2-0.4,0.7-0.4,1v34.3c0,7.3,5.9,13.2,13.2,13.2h24.4 c0.1,0,0.2-0.1,0.2-0.2l0-47C37.8,30.3,37.7,30.3,37.6,30.3z M31.3,59.8c0,0.4-0.4,0.8-0.8,0.8H17.8c-0.4,0-0.8-0.4-0.8-0.8V48 c0-0.4,0.4-0.8,0.8-0.8h12.8c0.4,0,0.8,0.4,0.8,0.8V59.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondTrust);
export default __webpack_public_path__ + "static/media/BeyondTrust.26ae24c975fc5bc3182c8bec04c0b924.svg";
export { ForwardRef as ReactComponent };